import { render, staticRenderFns } from "./user-status.vue?vue&type=template&id=372ed97c"
import script from "./user-status.vue?vue&type=script&lang=js"
export * from "./user-status.vue?vue&type=script&lang=js"
import style0 from "./user-status.vue?vue&type=style&index=0&id=372ed97c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports